import { render } from "./tolsAdmin.vue?vue&type=template&id=04a232e5"
import script from "./tolsAdmin.vue?vue&type=script&lang=js"
export * from "./tolsAdmin.vue?vue&type=script&lang=js"

import "./tolsAdmin.vue?vue&type=style&index=0&id=04a232e5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__